import {
  API_REQUEST,
  VTR_LIST_REQUEST,
  LOAD_IVRS_REQUEST,
  SUBMIT_TRIP,
  VTR_TRIP_DATA_REQUEST,
} from "../actions/actionTypes";
import { apiSuccess } from "../actions/api";
import { updateValidations } from "../actions/updateValidations";
import {
  baseServerUrl,
  default_request,
  TIMEOUT_MESSAGE,
  AXIOS_ERROR,
} from "../constants/default_request";
import { vtrLoadSucces, vtrLoadError } from "../actions/vtrList";
import { ivrLoadSuccess, ivrLoadError } from "../actions/ivrActions";
import { setError } from "../actions/errorActions";
import {
  newOpenTrip,
  submitTripError,
  submitTripSuccess,
  updateOpenTrip,
} from "../actions/newVtrTrip";
import { getOpenVtrTrips } from "../actions/vtrTripStorage";
import { isTestUser } from "../reducers/rootReducer";
import {
  DECIMAL_DEGREES,
  DEGREES_DECIMAL_MINUTES,
  DEGREES_MINUTES_SECONDS,
  pad,
} from "../constants/Effort";
import { getTimestamp } from "../actions/vtrIndexedDB";
import { userOffline } from "../actions/userOffLine";
import { BaseAPI } from "../apis/BaseAPI";
import { setStorageValue, removeStorageValue } from "../enhancers/utils";
import { filterLoginResponse } from "../enhancers/utils";

export const apiMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    let handledTypes = [
      API_REQUEST,
      VTR_LIST_REQUEST,
      LOAD_IVRS_REQUEST,
      SUBMIT_TRIP,
      VTR_TRIP_DATA_REQUEST,
    ];
    if (!handledTypes.includes(action.type)) return;

    if (action.type === API_REQUEST) {
      const { api_request_url, api_request_data, username, password } = action.meta;
      let errors = [];
      if (!username || !password) {
        errors[errors.length] = "No username or password provided.";
        dispatch(setError(errors));
      }
      // Retrieving timestamp from indexedDB.
      let downloadTimestamps = {};
      getTimestamp().then((timestamp) => {
        downloadTimestamps = { ...timestamp };
        api_request_data.download_timestamps = downloadTimestamps;
        if (errors.length === 0) {
          BaseAPI.call(api_request_url, api_request_data)
            .then((response) => {
              console.log("LoginResponse", response.data);
              const userResponse = { ...response.data, username };
              //API responded Oke , but now we need to find out if user is
              // logged in
              if (!response.data.hasOwnProperty("Status")) {
                errors[errors.length] = "Unknown status returned";
              }
              if (response.data.hasOwnProperty("Status")) {
                const responseStatus = response.data.Status.toUpperCase();
                const outStatus = ["LOGGED OUT", "ERROR"];
                const inStatus = ["LOGGED IN", "SUCCESS"];
                if (outStatus.includes(responseStatus)) {
                  // localStorage.removeItem("loginResponse");
                  removeStorageValue("loginResponse");
                  errors[errors.length] = "Invalid credentials";
                }
                if (inStatus.includes(responseStatus)) {
                  // * Updating the indexedDB store with values coming from the API.
                  // * Using custom hook to store loginResponse and handle possible errors.
                  dispatch(
                    updateValidations({
                      response: userResponse,
                      username,
                      password,
                    })
                  );
                  const filteredResponse = filterLoginResponse(userResponse);
                  // * Storing data from filtered response to local storage using hook
                  setStorageValue("loginResponse", filteredResponse);
                  setStorageValue("user", {
                    user_full_name: filteredResponse.user_full_name,
                    username: filteredResponse.username,
                  });

                  // * Dispatching login success to the Redux store
                  dispatch(apiSuccess({ response: userResponse }));
                }
                if (responseStatus === "ACCOUNT INCOMPLETE") {
                  errors[errors.length] = response.data.Status;
                }
              }
              dispatch(setError(errors));
            })
            .catch(function (error) {
              console.error(error);
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
                errors[errors.length] = error.response.data;
              } else if (error.message === "Network Error") {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // TODO: validate behavior of the app
                // errors[errors.length] = "Network Error";
                dispatch(userOffline({ username, password }));
              } else if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
                errors[errors.length] = TIMEOUT_MESSAGE;
              } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Error", error.message);
                if (error.message) {
                  errors[errors.length] = error.message;
                } else {
                  errors[errors.length] = "Unknown error occurred";
                }
              }
              console.error(error.config);
              console.error(errors);
              dispatch(setError(errors));
            });
        }
      });
      if (errors.length > 0) dispatch(setError(errors));
    }

    if (action.type === VTR_LIST_REQUEST) {
      const base_request_url = baseServerUrl + "/base_api/vtr_list";
      const payload = default_request(
        action.client_id,
        action.token,
        action.user_app_status
      );
      let request_url = "";
      let errors = [];

      if (isTestUser(action.user_app_status)) {
        request_url = base_request_url.concat("/test");
      } else {
        request_url = base_request_url;
      }
      BaseAPI.call(request_url, payload)
        .then((response) => {
          if (
            response.data.hasOwnProperty("STATUS") &&
            response.data.STATUS.toUpperCase() === "SUCCES"
          ) {
            const docList = [...response.data.DOC_LIST];
            let sortedDoc = [];
            docList
              .sort((a, b) => b.DATE_LAND.localeCompare(a.DATE_LAND))
              .map((trip) => sortedDoc.push(trip));

            const trips = {
              STATUS: response.data.STATUS,
              DOC_LIST: [...sortedDoc],
            };
            dispatch(
              vtrLoadSucces({
                response: { ...trips },
                client_id: action.client_id,
              })
            );
          } else {
            dispatch(vtrLoadError({ error: response.data }));
          }
        })
        .catch((error) => {
          let errorObj = {};
          console.log("getVtrList_error", error);
          if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
            errorObj.status = "ERROR";
            errorObj.message = TIMEOUT_MESSAGE;
          }
          errors.push(errorObj);
          dispatch(
            vtrLoadError({
              error: Object.keys(errorObj).length > 0 ? errorObj : error,
            })
          );
        });
    }

    if (action.type === VTR_TRIP_DATA_REQUEST) {
      const { api_request_url, client_id, token, user_app_status, trip_id } = action.meta;
      let errors = [];
      if (!client_id || !token) {
        errors[errors.length] = "No client id or token provided";
      }
      if (!trip_id) {
        errors[errors.length] = "No trip id provided";
      }
      let base_request_url = "";
      if (isTestUser(user_app_status)) {
        base_request_url = api_request_url.concat("/test");
      } else {
        base_request_url = api_request_url;
      }
      const request_data = default_request(client_id, token, user_app_status);
      request_data.tripid = trip_id;
      console.log(errors);
      if (errors.length === 0) {
        BaseAPI.call(base_request_url, request_data)
          .then((response) => {
            if (
              response.data.hasOwnProperty("STATUS") &&
              response.data.STATUS.toUpperCase() === "SUCCESS" &&
              response.data.hasOwnProperty("VTR_DOCID")
            ) {
              //Check if we have the same open trip
              let allOpenTrips = getOpenVtrTrips(client_id, trip_id, true);
              let openTripFound = false;
              if (allOpenTrips) {
                if (Array.isArray(allOpenTrips)) {
                  for (let e = 0; e < allOpenTrips.length; e++) {
                    console.log(allOpenTrips[e].trip_id + " === " + trip_id);
                    if (allOpenTrips[e].trip_id === trip_id) {
                      openTripFound = true;
                      dispatch(updateOpenTrip(response.data, client_id));
                    }
                  }
                } else {
                  openTripFound = true;
                  dispatch(updateOpenTrip(response.data, client_id));
                }
              }
              if (!openTripFound) {
                dispatch(newOpenTrip(response.data, client_id));
              }
            } else if (Object.keys(response.data).length === 0) {
              errors.push({
                status: "ERROR",
                message: "An error occur with the request.",
              });
              dispatch(setError(errors));
            } else {
              errors[errors.length] = response.data;
              dispatch(setError(errors));
            }
          })
          .catch((error) => {
            if (
              error === undefined ||
              isNaN(error) ||
              (Object.keys(error).length === 0 && error.constructor === Object)
            ) {
              errors.push({
                status: "ERROR",
                message: "An error occur with the request.",
              });
            } else if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
              errors.push({ status: "ERROR", message: TIMEOUT_MESSAGE });
            } else {
              errors[errors.length] = error;
            }
            dispatch(setError(errors));
          });
      }
      dispatch(setError(errors));
    }

    if (action.type === LOAD_IVRS_REQUEST) {
      let request_url = baseServerUrl + "/base_api/ivr_vessel";
      if (action.meta.test_user) request_url = request_url.concat("/test");
      let errorObj = {};

      BaseAPI.call(request_url, action.meta)
        .then((response) => {
          if (
            response.data.hasOwnProperty("status") &&
            response.data.status.toUpperCase() === "SUCCESS"
          ) {
            dispatch(ivrLoadSuccess(response.data));
          } else {
            dispatch(ivrLoadError({ error: response.data }));
          }
        })
        .catch((error) => {
          if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
            errorObj.name = error.name;
            errorObj.message = TIMEOUT_MESSAGE;
          }
          dispatch(
            ivrLoadError({
              error: Object.keys(errorObj).length > 0 ? errorObj : error,
            })
          );
        });
    }

    if (action.type === SUBMIT_TRIP) {
      console.log("SUBMIT_TRIP_ACTION_INFO", action);
      // todo: move logic of url assignment to a method.
      let base_request_url = `${baseServerUrl}/base_api/evtr`;
      let request_url = "";
      let errorArr = [];
      // * Added Lobster end-point condition
      if (action.meta.report_type === "2") {
        request_url = base_request_url.concat("/v_1_lobster");
      } else {
        request_url = base_request_url.concat("/v_1_sales");
      }
      let final_request_url = "";
      if (action.test_user) {
        final_request_url = request_url.concat("/test");
      } else {
        final_request_url = request_url;
      }
      const request_data = default_request(
        action.client_id,
        action.token,
        action.test_user ? "TEST" : null,
        false
      );
      let nrEfforts = 0;
      let nrCatches = 0;

      request_data.record_type = "1";
      request_data.trip_count = 1;
      request_data.vendor_message_id = null;
      request_data.trip_id = action.meta.trip_id;
      if (action.meta.hasOwnProperty("docid")) {
        request_data.document_id = action.meta.docid;
      }
      request_data.vessel_permit_num = action.meta.vessel_permit_num;
      request_data.vessel_registration = action.meta.vessel_registration;
      request_data.date_sail = action.meta.date_sail;
      request_data.date_land = action.meta.date_land;
      request_data.report_type = action.meta.report_type;
      request_data.trip_type = action.meta.trip_type;
      request_data.number_of_crew = action.meta.number_of_crew;
      request_data.number_of_anglers = action.meta.number_of_anglers;
      request_data.operator_first_name = action.meta.operator_first_name;
      request_data.operator_last_name = action.meta.operator_last_name;
      request_data.operator_ext_name = action.meta.operator_ext_name;
      request_data.operator_permit_number = action.meta.operator_permit_number;
      request_data.operator_password = null;
      request_data.no_effort_trip_reason = action.meta.no_effort_trip_reason;
      request_data.trip_comments = "";
      if (action.meta.report_type === "2") {
        request_data.traps_in_water_total = action.meta.trapsInWater;
        request_data.avg_traps_per_string = action.meta.trapsPerString;
        request_data.lines_in_water_total = action.meta.buoyLines;
      }

      if (
        !request_data.no_effort_trip_reason ||
        request_data.no_effort_trip_reason === "0"
      ) {
        const nrImages = action.meta.images.length;
        let saveImagesArray = [];
        let saveImagesObject = {};

        for (let i = 0; i < nrImages; i++) {
          nrEfforts++;
          let latitude = null;
          let longitude = null;
          let currentImage = action.meta.images[i];
          if (currentImage.lat_long_format !== "") {
            let currentLatitude = currentImage.latitude_or_loran1;
            let currentLongitude = currentImage.longitude_or_loran2;
            if (currentImage.lat_long_format === DECIMAL_DEGREES) {
              latitude = currentLatitude.decimal_degrees;
              longitude = currentLongitude.decimal_degrees;
            }
            if (currentImage.lat_long_format === DEGREES_DECIMAL_MINUTES) {
              latitude =
                currentLatitude.degrees_decimal_minutes.degrees.padStart(2, "0") +
                ":" +
                currentLatitude.degrees_decimal_minutes.minutes.trim().padStart(2, "0");
              if (currentLongitude.degrees_decimal_minutes.minutes.trim().includes(".")) {
                let degrees = currentLongitude.degrees_decimal_minutes.degrees;
                degrees = degrees.padStart(2, "0");
                let minutesInteger =
                  currentLongitude.degrees_decimal_minutes.minutes.trim();
                minutesInteger = minutesInteger
                  .substr(0, minutesInteger.indexOf("."))
                  .padStart(2, 0);

                let minutesFraction =
                  currentLongitude.degrees_decimal_minutes.minutes.trim();
                minutesFraction = minutesFraction
                  .substr(minutesFraction.indexOf(".") + 1)
                  .padEnd(2, "0");

                longitude = `${degrees}:${minutesInteger}.${minutesFraction}`;
              } else {
                longitude =
                  currentLongitude.degrees_decimal_minutes.degrees +
                  ":" +
                  currentLongitude.degrees_decimal_minutes.minutes
                    .trim()
                    .padStart(2, "0");
              }
            }
            if (currentImage.lat_long_format === DEGREES_MINUTES_SECONDS) {
              latitude =
                currentLatitude.degrees_minutes_seconds.degrees.padStart(2, "0") +
                ":" +
                currentLatitude.degrees_minutes_seconds.minutes
                  .trim()
                  .substr(0, 2)
                  .padStart(2, "0") +
                "." +
                currentLatitude.degrees_minutes_seconds.seconds
                  .trim()
                  .substr(0, 2)
                  .padStart(2, "0");

              longitude =
                currentLongitude.degrees_minutes_seconds.degrees.padStart(2, "0") +
                ":" +
                currentLongitude.degrees_minutes_seconds.minutes
                  .trim()
                  .substr(0, 2)
                  .padStart(2, "0") +
                "." +
                currentLongitude.degrees_minutes_seconds.seconds
                  .trim()
                  .substr(0, 2)
                  .padStart(2, "0");
            }
          }
          let catchArray = [];
          let currentNrCatches = currentImage.catch.length;
          if (currentNrCatches > 0) {
            for (let c = 0; c < currentNrCatches; c++) {
              let thisCatch = currentImage.catch[c];
              nrCatches++;

              let carr = {
                record_type: "1",
                species: thisCatch.species,
                kept: thisCatch.kept,
                discarded: thisCatch.discarded,
                uom: thisCatch.uom,
              };
              catchArray[c] = carr;
            }
          }
          // * Added validation for the Tow/Soak time
          let validTowSoakTime = "";
          if (
            currentImage.tow_soak_time.hours !== "" &&
            currentImage.tow_soak_time.minutes !== ""
          ) {
            validTowSoakTime =
              pad(currentImage.tow_soak_time.hours, 2) +
              ":" +
              pad(currentImage.tow_soak_time.minutes, 2);
          }
          saveImagesObject = {
            record_type: "1",
            gearcode: currentImage.gearcode,
            gearqty: currentImage.gearqty,
            gearsize: currentImage.gearsize,
            mesh_size: currentImage.mesh_size,
            latitude_or_loran1: latitude,
            longitude_or_loran2: longitude,
            chart_area: currentImage.chart_area,
            fishing_depth: currentImage.fishing_depth,
            fishing_depth_uom: currentImage.fishing_depth_uom,
            number_of_hauls: currentImage.number_of_hauls,
            tow_soak_time: validTowSoakTime,
            datetime_haul_start: null,
            datetime_haul_end: null,
            serial_num: currentImage.serial_num,
            vtr_serial_num: currentImage.vtr_serial_num,
            catch: catchArray,
          };
          if (action.meta.report_type === "2") {
            if (["PTLL", "PTCL"].includes(saveImagesObject.gearcode)) {
              // * Removing not required fields in case of existing data
              // * when the Gear is 'PTLL' or 'PTCL'
              saveImagesObject.gearsize = "";
              saveImagesObject.gearqty = "";
              saveImagesObject.number_of_hauls = "";
              saveImagesObject.tow_soak_time = "";

              // * updating lobster required fields values
              saveImagesObject.traps_per_effort = currentImage.numTrapsHauled;
              saveImagesObject.traps_in_water_per_area = currentImage.numTrapsInWater;
              saveImagesObject.traps_per_string_per_area = currentImage.numTrapsPerString;
              saveImagesObject.lines_in_water_per_area = currentImage.numBuoyLines;
              saveImagesObject.strings_hauled_per_effort = currentImage.stringsHauled;
              saveImagesObject.avg_soak_time_per_effort = currentImage.avgSoakTime;
              saveImagesObject.avg_soak_time_per_effort_uom = "hours";
            } else {
              // * clearing out the required fields for non lobster gear
              saveImagesObject.traps_per_effort = "";
              saveImagesObject.traps_in_water_per_area = "";
              saveImagesObject.traps_per_string_per_area = "";
              saveImagesObject.lines_in_water_per_area = "";
              saveImagesObject.strings_hauled_per_effort = "";
              saveImagesObject.avg_soak_time_per_effort = "";
              saveImagesObject.avg_soak_time_per_effort_uom = "";
            }
          }
          saveImagesArray[i] = saveImagesObject;
        }
        request_data.subtrips = saveImagesArray;
        request_data.effort_record_count_by_trip = nrEfforts;
        request_data.effort_count = nrEfforts;
        request_data.catch_count = nrCatches;

        if (action.sales_trip) {
          let editedSales = action.meta.sales;
          editedSales.forEach((sale) => {
            const tagNumbers = sale.tag_numbers;
            if (tagNumbers.length > 0) {
              tagNumbers.forEach((range) => {
                if (range && !range.hasOwnProperty("end")) {
                  range.end = range.start;
                }
              });
            }
          });
          request_data.sales = editedSales;
        }
      }
      BaseAPI.call(final_request_url, request_data)
        .then((response) => {
          if (
            response.data.hasOwnProperty("status") &&
            (response.data.status.toUpperCase() === "SUCCESS" ||
              response.data.status.toUpperCase() === "REPORT ACCEPTED")
          ) {
            dispatch(
              submitTripSuccess({
                client_id: action.client_id,
                trip_id: action.trip_id,
                data: response.data,
              })
            );
          } else {
            dispatch(
              submitTripError({
                error: response.data.errors,
                trip_id: action.trip_id,
                client_id: action.client_id,
              })
            );
          }
        })
        .catch((error) => {
          if (error.hasOwnProperty("name") && error.name === AXIOS_ERROR) {
            errorArr.push(TIMEOUT_MESSAGE);
          } else {
            errorArr = [...error];
          }
          dispatch(
            submitTripError({
              error: errorArr,
              trip_id: action.trip_id,
              client_id: action.client_id,
            })
          );
        });
    }
  };
